import React, { useEffect, useState } from 'react';
import { ToggleButtonWrapper, ApplyStyleWrapper, CancelStyleWrapper } from '../Button/ToggleButton/ToggleButtonStyle';
import { useSelector, useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { pushChipArrayAddCriteria, pushShowCard, pushApplyEvent, pushCancelEvent, pushClearAllEvent, pushRiskBody, pushRecoReqBody, pushAccountRiskBody, setAccordionOpen, setSearchString, pushClearFilterArray, pushSelectedChipArray } from '../../slices/RiskFilterSlice';
import constants, { originFilterUrl, accountFilterUrl, recommendationUrl } from '../../constants/constants';
import { getPostResponseAPIData } from '../../services/apiservices';
import { pushOverallHeatMap } from '../../slices/HeatMapSlice';
import { pushRestrictValue, pushShowApply, pushShowApplyReco } from '../../slices/ButtonsSlice';
import { pushRiskTableData, pushTableData } from '../../slices/recommendationTableSlice';
import { pushAccountWiseHeatMap } from '../../slices/ApplicationDrillHeatMapSlice';
import { pushShowSpinner, pushHideSpinner } from '../../slices/SpinnerSlice';
import { pushExportFilterRecommandationApi, pushExportFilterRiskApi } from '../../slices/ApiStateSlice';
import { makeStyles } from '@material-ui/core';
const useStyles = makeStyles({
  applyBtn: {
    background: '#005099 !important',
    color: 'white !important'
  }
});

const DefineQuery = props => {
  const classes = useStyles();
  const selectedChipArray = useSelector(state => state.riskFilterSlice.selectedChipArray);
  const clearAllEvent = useSelector(state => state.riskFilterSlice.clearAllEvent);
  const initialLimit = useSelector(state => state.riskFilterSlice.initialLimit);
  const initialOffset = useSelector(state => state.riskFilterSlice.initialOffset);
  const tabFlag = useSelector(state => state.buttonSlice.tabFlag);
  let finalChipArray = useSelector(state => state.riskFilterSlice.FinalChipArray);
  const filterQueryArray = useSelector(state => state.riskFilterSlice.filterQueryArray);
  const originFilterResponse = useSelector(state => state.recommendationTable.originFilter);
  const accountFilterResponse = useSelector(state => state.recommendationTable.accountFilter);
  const recoOriginFilter = useSelector(state => state.recommendationTable.recoOriginFilter);
  const riskApiResponseData = useSelector(state => state.recommendationTable.riskResponse);
  const recoApiResponseData = useSelector(state => state.recommendationTable.dashboardResponse);
  const clickEvent = useSelector(state => state.applicationDrillHeatMap.clickEvent);
  const envClickEvent = useSelector(state => state.applicationDrillHeatMap.envClickEvent);
  const selectedApplication = useSelector(state => state.heatMapSlice.selectedApplication);
  const selectedAccount = useSelector(state => state.applicationDrillHeatMap.selectedAccount);
  const dispatch = useDispatch();
  const [chipArray, setChipArray] = useState([]);
  let responseData = [];
  useEffect(() => {
    if (originFilterResponse && !originFilterResponse?.isLoading && originFilterResponse.data) {
      responseData = originFilterResponse.data.responseList;
      dispatch(pushOverallHeatMap(responseData));
      dispatch(pushRiskTableData(responseData));
      dispatch(pushShowApply(false));
      dispatch(pushHideSpinner(false));
    }
  }, [originFilterResponse]);
  let accountResponseData = [];
  useEffect(() => {
    if (accountFilterResponse && !accountFilterResponse?.isLoading && accountFilterResponse.data) {
      accountResponseData = accountFilterResponse.data.responseList;
      dispatch(pushAccountWiseHeatMap(accountResponseData));
      dispatch(pushRiskTableData(accountResponseData));
      dispatch(pushShowApply(false));
      dispatch(pushHideSpinner(false));
    }
  }, [accountFilterResponse]);
  useEffect(() => {
    if (recoOriginFilter && !recoOriginFilter?.isLoading && recoOriginFilter.data) {
      let recoResponseData = recoOriginFilter.data.responseList;
      dispatch(pushTableData(recoResponseData));
      dispatch(pushShowApplyReco(false));
      dispatch(pushHideSpinner(false));
    }
  }, [recoOriginFilter]);
  let clearAllDataOrigin = [];

  if (riskApiResponseData && !riskApiResponseData?.isLoading && riskApiResponseData.data) {
    clearAllDataOrigin = riskApiResponseData.data.responseList;
  }

  const accountWiseApiResponseData = useSelector(state => state.recommendationTable.applicationDrillHeatmap);
  const envApiResponseData = useSelector(state => state.recommendationTable.AccountResponse);
  const drillApiResponseData = useSelector(state => state.recommendationTable.ApplicationResponse);
  let accountTableData = [];

  if (drillApiResponseData && !drillApiResponseData?.isLoading && drillApiResponseData.data.responseList.length) {
    accountTableData = drillApiResponseData.data.responseList;
  }

  let drillFilterData = [];

  if (accountWiseApiResponseData && !accountWiseApiResponseData?.isLoading && accountWiseApiResponseData.data) {
    drillFilterData = accountWiseApiResponseData.data.responseList;
  }

  let tableData = [];

  if (recoApiResponseData && recoApiResponseData?.isLoading && recoApiResponseData.data) {
    tableData = recoApiResponseData.data.responseList;
  }

  let envTableData = [];

  if (envApiResponseData && envApiResponseData?.isLoading && envApiResponseData.data) {
    envTableData = envApiResponseData.data.responseList;
  }

  const runFilter = () => {
    let queryParam = [...new Set(finalChipArray.concat(selectedChipArray))];
    dispatch(pushChipArrayAddCriteria(chipArray));
    dispatch(pushShowCard(false));
    dispatch(pushApplyEvent(true));
    dispatch(pushClearAllEvent(false));
    dispatch(pushRestrictValue(false));
    dispatch(pushOverallHeatMap([]));
    dispatch(setSearchString(''));
    const {
      operationsNamesArray
    } = constants;
    let operationsArr = operationsNamesArray;
    const riskReqBody = {
      filter: '',
      limit: initialLimit,
      offset: initialOffset,
      sortBy: 'originRiskScore:DSC'
    };
    const recoReqBody = {
      fieldList: null,
      filter: '',
      limit: initialLimit,
      objectType: null,
      offset: initialOffset,
      recommendationOrImpact: 'Recommendation',
      sortBy: 'originRiskScore:DSC'
    };
    let keyJson = [];

    for (let tagItem of queryParam) {
      let selectedOpr = '';

      for (let oprationItem of operationsArr) {
        if (tagItem.indexOf(' contains ') > -1) {
          selectedOpr = 'contains';
          break;
        } else if (tagItem.indexOf(' startsWith ') > -1) {
          selectedOpr = 'startsWith';
          break;
        } else if (tagItem.indexOf(' endsWith ') > -1) {
          selectedOpr = 'endsWith';
          break;
        } else if (tagItem.indexOf(oprationItem) > -1) {
          selectedOpr = oprationItem;
          break;
        } else {
          selectedOpr = oprationItem;
          break;
        }
      }

      let tagStringArray = [];

      if (tagItem.indexOf(selectedOpr) > -1) {
        tagStringArray = tagItem.split(' ' + selectedOpr + ' ');
      }

      let existIndex = keyJson.findIndex(el => el.entityName === tagStringArray[0] && el.entityOpr === selectedOpr);

      if (existIndex > -1 && selectedOpr !== 'is') {
        keyJson[existIndex].entityValue += ', ' + tagStringArray[1];
      } else {
        let obj = {};
        obj['entityName'] = tagStringArray[0];
        obj['entityValue'] = tagStringArray[1];
        obj['entityOpr'] = selectedOpr;
        keyJson.push(obj);
      }
    }

    let stringCreated = tabFlag ? [] : props.watch === 1 ? ['underWatch=1', 'recoType=Any'] : ['recoType=Any'];
    let isNameValue = [];
    let isAppTypeValue = [];
    let isEnvTypeValue = [];
    let isEntityRiskValue = [];
    let isEntityNameValue = [];
    let isEntityTypeValue = [];
    let isEnvNameValue = [];
    let isAppValueType = [];

    for (let item of keyJson) {
      if (item.entityOpr === 'is') {
        switch (item.entityName) {
          case 'Application Name':
            {
              isNameValue.push(item.entityValue);
              break;
            }

          case 'Application Type':
            {
              isAppValueType.push(item.entityValue);
              break;
            }

          case 'Environment Name':
            {
              isEnvNameValue.push(item.entityValue);
              break;
            }

          case 'Application Risk Category':
            {
              isAppTypeValue.push(item.entityValue);
              break;
            }

          case 'Environment Risk Category':
            {
              isEnvTypeValue.push(item.entityValue);
              break;
            }

          case 'Entity Risk Category':
            {
              isEntityRiskValue.push(item.entityValue);
              break;
            }

          case 'Entity Name':
            {
              isEntityNameValue.push(item.entityValue);
              break;
            }

          case 'Entity Type':
            {
              if (item.entityValue === 'User Account') {
                isEntityTypeValue.push('UserAccount');
              } else {
                isEntityTypeValue.push(item.entityValue);
              }

              break;
            }

          case 'Application Risk Score':
          case 'Environment Risk Score':
          case 'Entity Risk Score':
            {
              let score = item.entityValue.split(' to ');

              if (item.entityName === 'Application Risk Score' && tabFlag) {
                stringCreated.push(`originRiskScore>${score[0]},originRiskScore<${score[1]}`);
              } else if (item.entityName === 'Environment Risk Score' && !tabFlag) {
                stringCreated.push(`accountRiskScore>${score[0]},accountRiskScore<${score[1]}`);
              } else if (item.entityName === 'Entity Risk Score') {
                stringCreated.push(`entityRiskScore>${score[0]},entityRiskScore<${score[1]}`);
              } else {
                stringCreated.push(`originRiskScore>${score[0]},originRiskScore<${score[1]}`);
              }

              break;
            }

          default:
            break;
        }
      } else if (item.entityOpr === 'contains') {
        const {
          entityName
        } = item;

        switch (entityName) {
          case 'Application Name':
            stringCreated.push(`origin:c:${item.entityValue}`);
            break;

          case 'Environment Name':
            stringCreated.push(`envName:c:${item.entityValue}`);
            break;

          case 'Entity Name':
            stringCreated.push(`objectName:c:${item.entityValue}`);
            break;

          case 'Entity Type':
            stringCreated.push(`objectType:c:${item.entityValue}`);
            break;

          case 'Application Type':
            stringCreated.push(`appType:c:${item.entityValue}`);
            break;

          default:
            break;
        }
      } else if (item.entityOpr === 'startsWith') {
        const {
          entityName
        } = item;

        switch (entityName) {
          case 'Application Name':
            stringCreated.push(`origin:sw:${item.entityValue}`);
            break;

          case 'Environment Name':
            stringCreated.push(`envName:sw:${item.entityValue}`);
            break;

          case 'Entity Name':
            stringCreated.push(`objectName:sw:${item.entityValue}`);
            break;

          case 'Entity Type':
            stringCreated.push(`objectType:sw:${item.entityValue}`);
            break;

          case 'Application Type':
            stringCreated.push(`appType:sw:${item.entityValue}`);
            break;

          default:
            break;
        }
      } else if (item.entityOpr === 'endsWith') {
        const {
          entityName
        } = item;

        switch (entityName) {
          case 'Application Name':
            stringCreated.push(`origin:ew:${item.entityValue}`);
            break;

          case 'Environment Name':
            stringCreated.push(`envName:ew:${item.entityValue}`);
            break;

          case 'Entity Name':
            stringCreated.push(`objectName:ew:${item.entityValue}`);
            break;

          case 'Entity Type':
            stringCreated.push(`objectType:ew:${item.entityValue}`);
            break;

          case 'Application Type':
            stringCreated.push(`appType:ew:${item.entityValue}`);
            break;

          default:
            break;
        }
      }
    }

    if (isNameValue.length > 1) {
      stringCreated.push([`origin:in:${isNameValue.join('$$')}`]);
    } else if (isNameValue.length > 0) {
      stringCreated.push([`origin=${isNameValue}`]);
    }

    if (isEntityTypeValue.length > 1) {
      stringCreated.push([`objectType:in:${isEntityTypeValue.join('$$')}`]);
    } else if (isEntityTypeValue.length > 0) {
      stringCreated.push([`objectType=${isEntityTypeValue}`]);
    }

    if (isEnvNameValue.length > 1) {
      stringCreated.push([`envName:in:${isEnvNameValue.join('$$')}`]);
    } else if (isEnvNameValue.length > 0) {
      stringCreated.push([`envName=${isEnvNameValue}`]);
    }

    if (isAppValueType.length > 1) {
      stringCreated.push([`appType:in:${isAppValueType.join('$$')}`]);
    } else if (isAppValueType.length > 0) {
      stringCreated.push([`appType=${isAppValueType}`]);
    }

    if (isEntityNameValue.length > 1) {
      stringCreated.push([`objectName:in:${isEntityNameValue.join('$$')}`]);
    } else if (isEntityNameValue.length > 0) {
      stringCreated.push([`objectName=${isEntityNameValue}`]);
    }

    if (isAppTypeValue.length > 1) {
      stringCreated.push([`originRiskCategory:in:${isAppTypeValue.join('$$')}`]);
    } else if (isAppTypeValue.length > 0) {
      stringCreated.push([`originRiskCategory=${isAppTypeValue.join('$$')}`]);
    }

    if (isEnvTypeValue.length > 1) {
      if (tabFlag) {
        stringCreated.push([`originRiskCategory:in:${isEnvTypeValue.join('$$')}`]);
      } else {
        stringCreated.push([`accountRiskCategory:in:${isEnvTypeValue.join('$$')}`]);
      }
    } else if (isEnvTypeValue.length > 0) {
      if (tabFlag) {
        stringCreated.push([`originRiskCategory=${isEnvTypeValue.join('$$')}`]);
      } else {
        stringCreated.push([`accountRiskCategory=${isEnvTypeValue.join('$$')}`]);
      }
    }

    if (isEntityRiskValue.length > 1) {
      stringCreated.push([`entityRiskCategory:in:${isEntityRiskValue.join('$$')}`]);
    } else if (isEntityRiskValue.length > 0) {
      stringCreated.push([`entityRiskCategory=${isEntityRiskValue.join('$$')}`]);
    }

    if (clickEvent) {
      stringCreated.push(`origin=${selectedApplication}`);

      if (tabFlag) {
        riskReqBody.sortBy = 'users:DSC';
      } else {
        recoReqBody.sortBy = 'accountRiskScore:DSC';
      }
    }

    if (envClickEvent) {
      props.watch === 1 ? stringCreated.push(`origin=${selectedApplication},underWatch=1,recoType=Any`) : stringCreated.push(`origin=${selectedApplication},recoType=Any`);
      stringCreated.push(`envName=${selectedAccount}`);
      recoReqBody.sortBy = 'entityRiskScore:DSC';
    }

    riskReqBody.filter = stringCreated.join(',');
    recoReqBody.filter = stringCreated.join(',');

    if (filterQueryArray && filterQueryArray.length >= 3) {
      if (clickEvent && !envClickEvent) {
        if (tabFlag) {
          dispatch(pushShowSpinner(true));
          dispatch(getPostResponseAPIData(accountFilterUrl, 'accountFilter', riskReqBody));
          dispatch(pushExportFilterRiskApi(accountFilterUrl));
          dispatch(pushAccountRiskBody(riskReqBody));
        } else {
          dispatch(pushShowSpinner(true));
          dispatch(getPostResponseAPIData(recommendationUrl, 'recoOriginFilter', recoReqBody));
          dispatch(pushExportFilterRecommandationApi(recommendationUrl));
          dispatch(pushRecoReqBody(recoReqBody));
        }
      } else if (!clickEvent && !envClickEvent) {
        if (tabFlag) {
          dispatch(pushShowSpinner(true));
          dispatch(getPostResponseAPIData(originFilterUrl, 'originFilter', riskReqBody));
          dispatch(pushExportFilterRiskApi(originFilterUrl));
          dispatch(pushRiskBody(riskReqBody));
        } else {
          dispatch(pushShowSpinner(true));
          dispatch(getPostResponseAPIData(recommendationUrl, 'recoOriginFilter', recoReqBody));
          dispatch(pushExportFilterRecommandationApi(recommendationUrl));
          dispatch(pushRecoReqBody(recoReqBody));
        }
      } else if (clickEvent && envClickEvent) {
        dispatch(pushShowSpinner(true));
        dispatch(getPostResponseAPIData(recommendationUrl, 'recoOriginFilter', recoReqBody));
        dispatch(pushExportFilterRecommandationApi(recommendationUrl));
        dispatch(pushRecoReqBody(recoReqBody));
      }
    }

    dispatch(setAccordionOpen(false));
  };

  useEffect(() => {
    let existingArray = [...chipArray];
    selectedChipArray.forEach(chip => {
      existingArray.push(chip);
    });
    let unique = [...new Set(existingArray)];
    setChipArray(unique);
  }, [selectedChipArray]);
  let applyDisable = !(filterQueryArray.length > 0 && filterQueryArray[2] && filterQueryArray[2].length > 0);
  return /*#__PURE__*/React.createElement(ToggleButtonWrapper, null, /*#__PURE__*/React.createElement(ApplyStyleWrapper, {
    onClick: runFilter,
    className: classes.applyBtn,
    disabled: applyDisable
  }, "Apply"), /*#__PURE__*/React.createElement(CancelStyleWrapper, {
    onClick: () => {
      if (clearAllEvent) {
        if (!clickEvent && !envClickEvent) {
          dispatch(pushOverallHeatMap(clearAllDataOrigin));
          dispatch(pushRiskTableData(clearAllDataOrigin));
          dispatch(pushTableData(tableData));
        } else if (clickEvent && !envClickEvent) {
          dispatch(pushAccountWiseHeatMap(drillFilterData));
          dispatch(pushRiskTableData(drillFilterData));
          dispatch(pushTableData(accountTableData));
        } else if (envClickEvent) {
          dispatch(pushTableData(envTableData));
        } else if (selectedAccount && selectedAccount.length > 0) {
          dispatch(pushTableData(envTableData));
        } else if (selectedApplication && selectedApplication.length > 0) {
          dispatch(pushTableData(accountTableData));
        }

        dispatch(pushShowApply(false));
        dispatch(pushRestrictValue(false));
        dispatch(pushShowCard(false));
        dispatch(pushCancelEvent(true));
        dispatch(pushShowApplyReco(false));
      } else {
        dispatch(pushShowApply(false));
        dispatch(pushShowCard(false));
        dispatch(pushCancelEvent(true));
        dispatch(pushRestrictValue(false));
        dispatch(pushShowApplyReco(false));
        dispatch(pushTableData(tableData));

        if (selectedApplication && selectedApplication.length > 0 && !selectedAccount) {
          dispatch(pushTableData(accountTableData));
        }

        if (selectedAccount && selectedAccount.length > 0) {
          dispatch(pushTableData(envTableData));
        }
      }

      dispatch(setAccordionOpen(false));
      dispatch(setSearchString(''));
      dispatch(pushClearFilterArray([]));
      dispatch(pushSelectedChipArray([]));
    }
  }, "Cancel"));
};

export default withRouter(DefineQuery);